import PropTypes from 'prop-types'

export const EventType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  venue_group: VenueGroupType,
  venues: PropTypes.arrayOf(VenueType),
  artists: PropTypes.arrayOf(ArtistType),
  sessions: PropTypes.arrayOf(SessionType),
})

export const CategoryType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
})

export const VenueType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  short_title: PropTypes.string,
})

export const VenueGroupType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  venues: PropTypes.arrayOf(VenueType).isRequired,
})

export const ArtistType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
})

export const SessionType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string,
  datetime: PropTypes.string.isRequired,
  is_range: PropTypes.bool.isRequired,
  endtime: PropTypes.string,
  venue: VenueType,
})

export const locationType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  short_title: PropTypes.string,
  distance: PropTypes.number.isRequired,
})
